import { h } from "preact"

function Icon(){
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="19.9412" y="3" width="1.4974" height="23.9584" rx="0.748701" transform="rotate(45 19.9412 3)" fill="#0B1426"/>
      <rect width="1.4974" height="23.9584" rx="0.748701" transform="matrix(-0.707107 0.707107 0.707107 0.707107 4.05884 3)" fill="#0B1426"/>
    </svg>
  )
}

export default Icon
